<div class="h-100">
    <ng-content></ng-content>
</div>